import Immutable from "seamless-immutable";

const initialState = Immutable({});

const BookingsReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default BookingsReducer;
